
export const socialNetworkLink = {
    "instagram": "https://www.instagram.com/thegemplatform",
    "facebook": "https://www.facebook.com/GEM-Global-Environment-Media-107023224212128/",
    "twitter": "https://twitter.com/TheGEMPlatform",
    "youtube": "https://www.youtube.com/channel/UCoh75HHdjvlHNwPjuVVO8_Q?view_as=subscriber",
    "linkedin": "https://www.linkedin.com/company/gem-global-environment-media",
}